import { useIntersectionObserver } from "../../hooks/useIntersectionObserver";

const MissionSection = () => {
  const [ref, isVisible] = useIntersectionObserver({
    threshold: 0.1,
    triggerOnce: true
  });

  return (
    <div className="px-6">
      <div className="max-w-7xl mx-auto">
        <div 
          ref={ref}
          className={`grid md:grid-cols-2 gap-12 mb-16 transition-all duration-1000 transform ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <div className="rounded-2xl p-6 bg-[#104B60]">
            <h2 className="text-4xl font-charter font-medium mb-6 text-[#FAF9F8]">Our mission...</h2>
            <p className="text-[#FAF9F8]">
              Empower digital marketers and businesses with a smarter way to manage sales and ad spend. By integrating multiple ad channels into one streamlined platform, we simplify campaign management and provide actionable insights that help businesses grow efficiently and profitably.
            </p>
          </div>
          <div className="rounded-2xl p-6 bg-[#104B60]">
            <h2 className="text-4xl font-charter font-medium mb-6 text-[#FAF9F8]">Our value proposition...</h2>
            <p className="text-[#FAF9F8]">
              Provide an affordable, all-in-one platform that centralizes ad spend management across multiple channels. Unlike traditional reporting tools, our solution includes a powerful budgeting feature that helps users not only analyze performance but also track spending against goals in real-time. This ensures better financial control, smarter decision-making, and maximized marketing impact – all at a price designed for growing businesses.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MissionSection;